<h3>Email Log</h3>

<div class="row" *ngIf="showJurisdictionSelection">
  <div class="form-group col">
    <label for="clientSelection" class="bmd-label-floating ml-3">
      Jurisdiction
    </label>
    <select
      class="form-control"
      [(ngModel)]="clientId"
      [ngModelOptions]="{ standalone: true }"
      name="clientSelection"
    >
      <option
        [ngValue]="j.id"
        *ngFor="let j of jurisdictions"
      >
        {{ j.name }}
      </option>
    </select>
  </div>
</div>

<ng-container *ngIf="clientId">
  <ul 
    ngbNav 
    #logEmails="ngbNav" 
    [destroyOnHide]="true" 
    class="nav-tabs"
  >
    <ng-container *ngIf="canViewLogEmails">
      <li ngbNavItem>
        <a [routerLink]="['application-log-emails']" ngbNavLink>
          Workflow Application Emails
        </a>
        <ng-template ngbNavContent>
          <wm-application-log-emails-list 
            #applicationLogEmailsList 
            [clientId]="clientId"
          ></wm-application-log-emails-list>
        </ng-template>
      </li>
    </ng-container>
  </ul>

  <div class="mt-5" [ngbNavOutlet]="logEmails"></div>
</ng-container>
